import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResourcesService } from '../services/resources.service';

@Component({
  selector: 'app-addnote-dialog',
  templateUrl: './addnote-dialog.component.html',
  styleUrls: ['./addnote-dialog.component.css']
})
export class AddnoteDialogComponent implements OnInit {

  constructor(@Inject (MAT_DIALOG_DATA) public data: any, public _dialogRef: MatDialogRef<AddnoteDialogComponent>, public _resourcesService: ResourcesService) { }

  public note = "";

  ngOnInit() {
    // console.log(this.data);
    if (this.data.note) {
      this.note = this.data.note;
    }
    
  }

  addResourceNote() {
    if (this.data.resource_note_id) {
      // This block edits user's note  
      let editObj = {resource_note_id: this.data.resource_note_id, note: this.note}
      this._resourcesService.editResourcesNote(editObj).subscribe(data => {
        // console.log(data);
        if (data.success) {
          this._dialogRef.close("Success");
        } else {
          this._dialogRef.close("Failed");
        }
      })
    } else {
      // This block adds a new note
      let obj = {video_timestamp: this.data.video_timestamp, resource_id: this.data.resource_id, note: this.note};
      this._resourcesService.addResourcesNote(obj).subscribe(data => {
        // console.log(data);
        if (data.success) {
          this._dialogRef.close("Success");
        } else {
          this._dialogRef.close("Failed");
        }
      })
    }
  }

}
